import { CONE_WIDTH } from "scripts/api/sector";
import { state } from "scripts/app";
import { MessageToast } from "scripts/ui/components/toast";

export class ConeControls {

    // Угол развертки сектора
    coneToggleBtn: HTMLButtonElement;
    conePopup: HTMLElement;
    coneInput: HTMLInputElement;


    constructor (){
        const coneToggleBtn = document.getElementById('coneToggleBtn');
        const conePopup = document.getElementById('conePopup');
        const coneInput = document.getElementById('coneWidthInput');

        if( !(coneToggleBtn instanceof HTMLButtonElement) ||
            !(conePopup instanceof HTMLElement) ||
            !(coneInput instanceof HTMLInputElement)
        ){
            throw new Error('Ошибка! Отсутствует поле ввода в блоке управления!');
        }

        // Угол развертки сектора
        this.coneToggleBtn = coneToggleBtn;
        this.conePopup = conePopup;
        this.coneInput = coneInput;

        this.coneInput.value = localStorage.getItem(CONE_WIDTH) ?? '30';

        this.conePopup.style.display = 'none';
        this.addEventListeners();        
    }

    public setCone(value: number){
        localStorage.setItem(CONE_WIDTH, value.toString());
        this.coneInput.value = value.toString();
    }
    public getCone(): number{
        return parseInt(this.coneInput.value);
    }

    private changeCone(){
        if (!state.detector) {
            MessageToast.showDanger('Отсутствует сектор');
            return;
        }

        let v = parseFloat(this.coneInput.value);
        if (isNaN(v)) return;
        v = Math.max(5, Math.min(180, v));

        localStorage.setItem(CONE_WIDTH, v.toString());

        // TODO: В детекторе написать изменение cone
        state.detector.setCone(v);
    }

    private addEventListeners() {
        this.coneInput.addEventListener('input', () => this.changeCone());
        this.coneInput.addEventListener('change', () => this.changeCone());
        this.coneToggleBtn.addEventListener('click', () => this.toggleModal());

        this.hideModalOutsideClick();
    }

    private toggleModal() {
        const visible = this.conePopup.classList.toggle('visible');
        this.conePopup.style.display = visible ? 'flex' : 'none';
    }

    /**
     * Активируем слушать при клике вне модального окна, для его закрытия
     */
    private hideModalOutsideClick(){
        document.addEventListener('click', (e) => {
            const target = e.target as Node;
            if (!this.conePopup.contains(target) && target !== this.coneToggleBtn && !this.coneToggleBtn.contains(target)) {
                this.conePopup.classList.remove('visible');
                this.conePopup.style.display = 'none';
            }
        });
    }   
}